import React from "react";
import { Formik, Form, Field, FieldArray } from "formik";
import * as Yup from "yup";
import {
  Button,
  Badge,
  CloseButton,
  InputGroup,
  Row,
  Col,
  Card,
} from "react-bootstrap";
import ProjectCodesServices from "../../../../services/ProjectCodeService";
import { useLoader } from "../../../../context/LoaderCotext";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const validationSchema = Yup.object().shape({
  fullName: Yup.string().required("Name is required"),
  employeeId: Yup.string().required("Employee ID is required"),
  projectCodes: Yup.array().of(Yup.string()).min(1, "At least one project code is required"),
});

const AddProjectCode = () => {
  const navigate = useNavigate();
  const { showLoader, hideLoader } = useLoader();
  const initialValues = {
    fullName: "",
    employeeId: "",
    projectCodes: [],
    currentProjectCode: "",
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    const formData = {
      fullName: values.fullName,
      employeeId: values.employeeId,
      projectCodes: values.projectCodes,
    };

    if (formData.projectCodes.length === 0 && values.currentProjectCode.trim() !== "") {
      formData.projectCodes.push(values.currentProjectCode.trim());
    }
    showLoader();
    try {
      await ProjectCodesServices.add(formData);
      toast.success("Project code added successfully!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000, // Closes after 3 seconds
      });
      // Delay navigation to ensure toast is visible
      setTimeout(() => {
        navigate("/settings/project-code");
      }, 3000);
      console.log("Project code added successfully");
      // Optionally, redirect or update state after successful add
    } catch (error) {
      console.error("Error adding project code:", error);
      toast.error("Failed to Update Project Code!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
      });
    }
    finally {
      hideLoader();
      
    }
  };

  return (
    <div>
      <Card>
        <h2>Add Project Code</h2>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, errors, touched, setFieldValue }) => (
            <Form>
              <Row>
                <Col>
                  <div controlId="fullName" className="form-group">
                    <label htmlFor="fullName">Name</label>
                    <Field
                      type="text"
                      name="fullName"
                      placeholder="Enter Employee Name"
                      className={`form-control ${touched.fullName && errors.fullName ? "is-invalid" : ""}`}
                    />
                    {touched.fullName && errors.fullName && <div className="invalid-feedback">{errors.fullName}</div>}
                  </div>
                </Col>
                <Col>
                  <div className="form-group" controlId="employeeId">
                    <label htmlFor="employeeId">Employee Id</label>
                    <Field
                      type="text"
                      name="employeeId"
                      placeholder="Enter Employee Id"
                      className={`form-control ${touched.employeeId && errors.employeeId ? "is-invalid" : ""}`}
                    />
                    {touched.employeeId && errors.employeeId && <div className="invalid-feedback">{errors.employeeId}</div>}
                  </div>
                </Col>
                <Col>
                  <div className="form-group" controlId="projectCodes">
                    <label htmlFor="projectCodes">Project Codes</label>
                    <InputGroup className="mb-3">
                      <Field
                        type="text"
                        name="currentProjectCode"
                        placeholder="Enter Project Code"
                        className="form-control"
                      />
                      <Button
                        variant="outline-secondary"
                        onClick={() => {
                          if (values.currentProjectCode.trim() !== "") {
                            setFieldValue("projectCodes", [...values.projectCodes, values.currentProjectCode.trim()]);
                            setFieldValue("currentProjectCode", "");
                          }
                        }}
                      >
                        Add
                      </Button>
                    </InputGroup>
                    <FieldArray name="projectCodes">
                      {({ remove }) => (
                        <div>
                          {values.projectCodes.map((projectCode, index) => (
                            <Badge key={index} pill bg="secondary" className="me-2">
                              {projectCode}{" "}
                              <CloseButton
                                onClick={() => remove(index)}
                              />
                            </Badge>
                          ))}
                        </div>
                      )}
                    </FieldArray>
                    {touched.projectCodes && errors.projectCodes && <div className="text-danger">{errors.projectCodes}</div>}
                  </div>
                </Col>
              </Row>
              <div className="d-flex justify-content-end">
                <Button variant="primary" type="submit">
                  Add Project Code
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </Card>
      {/* Toast Notification Container */}
      <ToastContainer />
    </div>
  );
};

export default AddProjectCode;